import request from '@/utils/request'

export function getBusinessTodoCounts() {
  return request({
    url: '/pc-api/inquiry/todo/counts',
    method: 'get'
  })
}
